const TRIAL_ITEMS = [
  {
    metric: '8GB',
    title: '合計8GBまで',
    description: '1件のプロジェクトに、合計8GBまで動画をアップロードできます。',
  },
  {
    metric: '1 LINK',
    title: '共有リンクを1本発行',
    description: '相手が動画を受け取れる共有リンクを1本作れます。',
  },
  {
    metric: 'KEEP',
    title: '無料登録後もそのまま使える',
    description: 'お試し中にアップロードした動画と共有リンクは、無料登録後もそのまま残ります。',
  },
] as const

export function LandingTrial() {
  return (
    <section className="relative overflow-hidden border-t border-white/10 bg-zinc-950 text-white">
      <div
        aria-hidden
        className="absolute -right-24 -top-24 size-80 rounded-full bg-primary/15 blur-3xl"
      />
      <div className="relative mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <h2 className="text-center text-2xl font-bold tracking-tight sm:text-3xl">
          まずは、実際の動画で
          <br className="sm:hidden" />
          お試しください
        </h2>
        <p className="mt-3 text-center text-sm text-white/55 sm:text-base">
          24時間、無料でアップロードから共有まで試せます。
        </p>
        <ul className="mt-10 grid gap-4 sm:grid-cols-3">
          {TRIAL_ITEMS.map((item) => (
            <li
              key={item.title}
              className="rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-sm"
            >
              <p className="font-mono text-2xl font-bold tracking-tight text-primary">
                {item.metric}
              </p>
              <h3 className="mt-4 text-sm font-bold">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55">{item.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
